import axios from 'axios';
import { showError } from '../utils/notifications';

// Create axios instance with default config
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for cookies
});

// Add request interceptor for auth tokens
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401) {
      // Don't show error notification if we're already on the login page
      const isLoginPage = window.location.pathname === '/login';
      
      // Remove user from localStorage
      localStorage.removeItem('user');
      
      // Only redirect and show error if we're not already on the login page
      if (!isLoginPage) {
        window.location.href = '/login';
        showError('Session expired. Please log in again.');
      }
    }
    return Promise.reject(error);
  }
);

export default api; 